import React from 'react'
import './PickerTextInput.scss'

const PickerTextInput = ({ id, onChange, value, onFocus, onBlur }) => {

  return (
    <div className='viso-color-picker-text-input'>
      <input
        type='text'
        id={id}
        name={id}
        className={`viso-color-picker-text-input__field viso-color-picker-text-input__field--${id}`}
        value={value}
        onFocus={onFocus}
        onChange={onChange}
        onBlur={onBlur}
      />
    </div>
  )
}

export default PickerTextInput